export enum AdditionalServicesEnum {
    'soft_package' = 'Мягкая упаковка',
    'grid' = 'Обрешетка',
    'loader' = 'Грузчики',
    'pallet' = 'Паллета',
    'hydraulic_trolley' = 'Рохля',
    'rise_to_the_floor' = 'Подъем на этаж',
}

export enum EditAdditionalServicesEnum {
    'soft_package' = 'Мягкая упаковка',
    'grid' = 'Обрешетка',
    'pallet' = 'Паллета',
    'loader' = 'Грузчики',
    'crane' = 'Кран',
    'manipulator' = 'Манипулятор',
    'hydraulic_trolley' = 'Рохля',
}
